import React from 'react'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'

import { LOCALE_PREFIX } from '../../constants'
import { creditInformationIsEmpty } from '../../helpers'

export default function CreditInformation({ data }) {
    if (creditInformationIsEmpty(data)) {
        return null
    }

    return (
        <>
            <div className={'row title'}>
                <FormattedMessage id={`${LOCALE_PREFIX}.creditInformation`} />
            </div>
            <div className={'block-separator'} />
            <div className={'row'}>
                {!_.isNil(data?.bisnodeScoring?.full?.value) ? (
                    <>
                        <div className={cx('scoring-code', `type-${data?.bisnodeScoring?.full?.value}`)} />
                        <span>{data?.bisnodeScoring?.full?.description}</span>
                    </>
                ) : (
                    <>
                        <div className={cx('scoring-code', `type-light-${data?.bisnodeScoring?.light?.value}`)} />
                        <span>{data?.bisnodeScoring?.light?.description}</span>
                    </>
                )}
            </div>
            {(!_.isNil(data?.paymentIndex?.full?.value) || !_.isNil(data?.paymentIndex?.light?.value)) && (
                <>
                    <div className={'block-separator'} />
                    <div className={'row'}>
                        {!_.isNil(data?.paymentIndex?.full?.value) ? (
                            <>
                                <div
                                    className={cx(
                                        'paymentIndex',
                                        data?.paymentIndex?.active
                                            ? `category-${data?.paymentIndex?.full?.category}`
                                            : 'inactive'
                                    )}
                                >
                                    <span>{data?.paymentIndex?.full?.value}</span>
                                </div>
                                {data?.paymentIndex?.full?.value < 0 ? (
                                    <FormattedMessage
                                        id={`${LOCALE_PREFIX}.beforeDue`}
                                        values={{ value: Math.abs(data?.paymentIndex?.full?.value) }}
                                    />
                                ) : (
                                    <FormattedMessage
                                        id={`${LOCALE_PREFIX}.afterDue`}
                                        values={{ value: Math.abs(data?.paymentIndex?.full?.value) }}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                <div
                                    className={cx('paymentIndex', `category-light-${data?.paymentIndex?.light?.value}`)}
                                />
                                <span>{data?.paymentIndex?.light?.description}</span>
                            </>
                        )}
                    </div>
                    <div className={'block-separator'} />
                </>
            )}
        </>
    )
}
